import { Upload } from 'antd'

import Icon from '../../svgs/Upload'

export default function UploadGeneral({ label, hint, fileList, onChange }) {
  return (
    <div>
      <label>{label}</label>
      <Upload
        className='upload-general'
        multiple
        fileList={fileList}
        onChange={onChange}
        beforeUpload={() => false}
      >
        <div className='bg-green_100 border border-dashed border-green rounded flex justify-center items-center text-green text-sm py-14'>
          <Icon styles='w-[1rem] ltr:mr-12 rtl:ml-12' /> {hint}
        </div>
      </Upload>
    </div>
  )
}
